import React from 'react';
import APopover from '../../views/pages/manage/common/a-popover';
import FormFields from './FormFields';
import AButton from '../../views/pages/manage/common/form-fields-mui/AButton';
import { Badge } from '@mui/material';

const defaultBtnComponent = <AButton variant='outline' size='xs' className='no-ml-btn'>Filter</AButton>

const AFilterForm = ({
    containerStyles = {},
    btnComponent = defaultBtnComponent,
    applyFilterHandler,
    removeFilterHandler,
    filterForm,
    handleFilterForm,
    formFields,
    twoColumnLayout =false
}) => {
    return ( 
          <APopover
              buttonComponent={(openPopover) => (
                <Badge badgeContent={filterForm?.appliedFilterCount ?? 0} color='primary'>
                <span onClick={openPopover}>
                 {btnComponent}
                </span>
                </Badge>
              )}
              menuComponent={(closePopup) => (
                <FormFields
                //   businessAreaDropdown={allActiveBu}
                twoColumnLayout ={twoColumnLayout}
                  formFields={formFields}
                  filterForm={filterForm}
                  applyFilterHandler={applyFilterHandler}
                  handleFilterForm={handleFilterForm}
                  closePopup={closePopup}
                  containerStyles={containerStyles}
                  removeFilterHandler={removeFilterHandler}
                // filterCount={getFilterCount()}
                />
              )}
            />
     );
}
 
export default AFilterForm;